import type { BadgeColor } from '@enamelai/design-system'
import { StatusTypes } from '@components/common/StatusBadge/StatusBadge.component'

export const PATIENT_STATUS: { [key: number]: StatusTypes } = {
  0: StatusTypes.Active,
  1: StatusTypes.Alert,
  2: StatusTypes.Allergies,
  3: StatusTypes.Alerts,
  4: StatusTypes.Appointments,
  5: StatusTypes.Archived,
  6: StatusTypes.Cancelled,
  7: StatusTypes.Conditions,
  8: StatusTypes.Completed,
  9: StatusTypes.Confirmed,
  10: StatusTypes.Deceased,
  11: StatusTypes.Deleted,
  12: StatusTypes.FollowUp,
  13: StatusTypes.FullTime,
  14: StatusTypes.Inactive,
  15: StatusTypes.Incomplete,
  16: StatusTypes.InvoiceSent,
  17: StatusTypes.Late,
  18: StatusTypes.Marketing,
  19: StatusTypes.NewPatient,
  20: StatusTypes.NonPatient,
  21: StatusTypes.NoShow,
  22: StatusTypes.PartTime,
  23: StatusTypes.Paid,
  24: StatusTypes.PaymentPending,
  25: StatusTypes.Payments,
  26: StatusTypes.Patient,
  27: StatusTypes.PatientLate,
  28: StatusTypes.Pending,
  29: StatusTypes.Prospective,
  30: StatusTypes.RevisionNeeded,
  31: StatusTypes.Records,
  32: StatusTypes.Scheduled,
  33: StatusTypes.Unpaid,
  34: StatusTypes.Draft,
}

/** Design-system badge color family for each patient status (same hue as the legacy StatusBadge). */
export const PATIENT_STATUS_BADGE_COLOR: Partial<
  Record<StatusTypes, BadgeColor>
> = {
  [StatusTypes.Active]: 'vivid-green',
  [StatusTypes.Alert]: 'red',
  [StatusTypes.Allergies]: 'purple',
  [StatusTypes.Alerts]: 'red',
  [StatusTypes.Appointments]: 'blue',
  [StatusTypes.Archived]: 'red',
  [StatusTypes.Cancelled]: 'red',
  [StatusTypes.Conditions]: 'yellow',
  [StatusTypes.Completed]: 'blue',
  [StatusTypes.Confirmed]: 'vivid-green',
  [StatusTypes.Deceased]: 'orange',
  [StatusTypes.Deleted]: 'orange',
  [StatusTypes.FollowUp]: 'blue',
  [StatusTypes.FullTime]: 'vivid-green',
  [StatusTypes.Inactive]: 'orange',
  [StatusTypes.Incomplete]: 'orange',
  [StatusTypes.InvoiceSent]: 'teal',
  [StatusTypes.Late]: 'red',
  [StatusTypes.Marketing]: 'indigo',
  [StatusTypes.NewPatient]: 'teal',
  [StatusTypes.NonPatient]: 'teal',
  [StatusTypes.NoShow]: 'yellow',
  [StatusTypes.PartTime]: 'orange',
  [StatusTypes.Paid]: 'vivid-green',
  [StatusTypes.PaymentPending]: 'orange',
  [StatusTypes.Payments]: 'vivid-green',
  [StatusTypes.Patient]: 'gray',
  [StatusTypes.PatientLate]: 'red',
  [StatusTypes.Pending]: 'gray',
  [StatusTypes.Prospective]: 'indigo',
  [StatusTypes.RevisionNeeded]: 'yellow',
  [StatusTypes.Records]: 'teal',
  [StatusTypes.Scheduled]: 'vivid-green',
  [StatusTypes.Unpaid]: 'red',
}
